import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Layout from '../components/Layout'
import QuickOfferTemplate from '../components/templates/QuickOfferTemplate'

const QuickOffer = ({data}) => {
  const frontmatter = get(data, 'markdownRemark.frontmatter', {})
  return (
    <Layout frontmatter={frontmatter}>
      <QuickOfferTemplate
        header={frontmatter.header}
        subheader={frontmatter.subheader}
        text={frontmatter.text}
        buttonText={frontmatter.buttonText}
        link={frontmatter.link}
        primaryColor={frontmatter.primaryColor}
        secondaryColor={frontmatter.secondaryColor}
        primaryTextColor={frontmatter.primaryTextColor}
        secondaryTextColor={frontmatter.secondaryTextColor}
      />
    </Layout>
  )
}

export default QuickOffer

export const pageQuery = graphql`
  query QuickOfferByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        templateKey
        title
        description
        favicon
        logo
        description
        header
        subheader
        text
        buttonText
        link
        primaryColor
        secondaryColor
        primaryTextColor
        secondaryTextColor
      }
    }
  }
`
